<section (click)="select(value)" class="card-customer" [class]="custumerIsSelected()" title="">
    <i class="np np-contact-1"></i>
    <div title={{value.name}}>
        <span>{{value.name}}</span>
    </div>
</section>